export const FILE_UPLOAD_STATES = {
  DONE: 'done',
  FAILED: 'error_upload',
  FILE_SIZe: 'error_file_size',
};

export const ALLOWED_DOC_TYPES = {
  IMAGE: 'image',
  DOC: 'doc',
  PDF: 'pdf',
};

export const MIME_TYPE_DOC_TYPE_MAP = {
  'image/jpeg': ALLOWED_DOC_TYPES.IMAGE,
  'image/jpg': ALLOWED_DOC_TYPES.IMAGE,
  'image/png': ALLOWED_DOC_TYPES.IMAGE,
  'application/pdf': ALLOWED_DOC_TYPES.PDF,
  'application/msword': ALLOWED_DOC_TYPES.DOC,
};
